/* URBAN VINYLS — motion + pequeñas interacciones (sin dependencias, ~2KB) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Reveal al hacer scroll (una sola vez por elemento) */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.uv-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* 2. Flechas para scrollers horizontales */
  function initScrollers(root) {
    (root || document).querySelectorAll('[data-uv-scroller]').forEach(function (wrap) {
      if (wrap.dataset.uvReady) return;
      wrap.dataset.uvReady = '1';
      var track = wrap.querySelector('.uv-scroller');
      var prev = wrap.querySelector('[data-uv-prev]');
      var next = wrap.querySelector('[data-uv-next]');
      if (!track || !prev || !next) return;
      function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width * 2 : 300; }
      function update() {
        prev.disabled = track.scrollLeft < 8;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      update();
    });
  }

  /* 3. Cuenta atrás: [data-uv-countdown="2026-10-02T14:00:00+02:00"] */
  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-uv-countdown]').forEach(function (el) {
      if (el.dataset.uvReady) return;
      el.dataset.uvReady = '1';
      var target = Date.parse(el.getAttribute('data-uv-countdown'));
      var host = el.closest('[data-uv-drop]');
      if (isNaN(target)) return;
      var parts = {
        d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'),
        m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]')
      };
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var diff = Math.max(0, target - Date.now());
        var s = Math.floor(diff / 1000);
        if (parts.d) parts.d.textContent = pad(Math.floor(s / 86400));
        if (parts.h) parts.h.textContent = pad(Math.floor((s % 86400) / 3600));
        if (parts.m) parts.m.textContent = pad(Math.floor((s % 3600) / 60));
        if (parts.s) parts.s.textContent = pad(s % 60);
        if (diff <= 0) {
          if (host && host.dataset.state === 'upcoming') host.dataset.state = 'live';
          return;
        }
        setTimeout(tick, 1000);
      }
      tick();
    });
  }

  /* 4. Variantes A/B del hero por URL: ?hero=a|b|c (para anuncios) */
  function initHeroVariant() {
    var m = location.search.match(/[?&]hero=([abc])/i);
    if (!m) return;
    var v = m[1].toLowerCase();
    document.querySelectorAll('[data-uv-hero]').forEach(function (hero) {
      hero.querySelectorAll('[data-variant]').forEach(function (n) {
        n.hidden = n.getAttribute('data-variant') !== v;
      });
      hero.dataset.activeVariant = v;
    });
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'hero_variant', hero_variant: v }); } catch (e) {}
  }

  function initAll(root) { initReveal(root); initScrollers(root); initCountdowns(root); }

  document.documentElement.classList.add('uv-js');
  initHeroVariant();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* Editor de temas: re-inicializar al cargar secciones */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
